module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch00_fm04_copy"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("Copyright © 1987 by Jeanette Winterson")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in any form or by any electronic or mechanical means, or the facilitation thereof, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer, who may quote brief passages in a review. Any members of educational institutions wishing to photocopy part or all of the work for classroom use, or publishers who would like to obtain permission to include the work in an anthology, should send their inquiries to Grove/Atlantic, Inc., 841 Broadway, New York, NY 10003.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("First published in Great Britain in 1987 by Bloomsbury Publishing Ltd.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_c('em', [_vm._v("Printed in the United States of America")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Winterson, Jeanette, 1959–")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The passion.")]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("     I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("PR6073.I558P36 1988 823’.914 88-3427")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("ISBN-13: 978-0-8021-3522-3")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Grove Press")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("an imprint of Grove/Atlantic, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("841 Broadway")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("New York, NY 10003")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Distributed by Publishers Group West")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.groveatlantic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.groveatlantic.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("09 10 11 12 15 14 13 12")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af8bb9fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm04_copy.vue
// module id = 72
// module chunks = 0